document.addEventListener("alpine:init", function () {
    Alpine.data('admin_credits_management_demographics_x_data', () => ({
        management_data: {},
        consumption_data: [],
        chart_view: 'all',
        chart_data: null,
        loaded_data: false,
        loading_chart: false,
        show_id: '',
        init() {
            this.$watch('chart_view', val => {
                this.get_usage_overtime()
            })
            this.chart_data = JSON.parse(this.$el.dataset.chartData)
            this.render_chart()
        },
        get_show_demographics_data(show_id) {
            this.show_id = show_id
            const demographicsDataUrl = `/admin/users/credits-management/${show_id}/demographics-data`
            fetch(demographicsDataUrl)
                .then(res => res.json())
                .then(data => {
                    console.log(data)
                    this.management_data = data.management_data
                    this.consumption_data = data.consumption_data
                    this.loaded_data = true
                })
        },
        format_date(dateString) {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        },
        format_number(number) {
            if (number === null || number === '') {
                return '0';
            }

            return new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }).format(parseFloat(number));
        },
        calculate_match_rate(totalExploriumCalls, totalRequests) {
            if (totalRequests > 0) {
                return ((totalExploriumCalls * 100 / totalRequests) / 100).toFixed(2) + '%';
            }
            return '0.00%';
        },
        get_this_month_credit_usage() {
            if (!this.consumption_data || this.consumption_data.length === 0) {
                return '0';
            }
            return String(this.consumption_data[this.consumption_data.length - 1][2] || '0')
        },
        render_chart() {
            new Chartkick.AreaChart('line-chart', this.chart_data, {
                colors: ["#CDC1ED"],
            })
        },
        get_usage_overtime() {
            this.loading_chart = true
            const demographicsUsageUrl = `/admin/users/credits-management/${this.show_id}/demographics-usage?chart_view=${this.chart_view}`
            fetch(demographicsUsageUrl)
                .then(res => res.json())
                .then(data => {
                    console.log(data)
                    this.chart_data = data.chart_data
                    this.render_chart()
                })
                .finally(() => this.loading_chart = false)
        }
    }))
})